import * as React from "react";
import { UserMessage } from "./userMessageTypes";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import PosConsoleApi from "app/utils/PosConsoleApi";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Grid, { GridProps } from "@material-ui/core/Grid";
import { DateTimePicker } from "material-ui-pickers";
import { fromMoment, toMoment } from "app/utils/filters";
import * as moment from "moment";

const update = require("immutability-helper");

type DeeplinkOption = {
  url: string;
  require_uid: boolean;
};

type Props = {
  message: UserMessage;
  editMode: boolean;
  onChangeMessage?: Function;
  onBumpVersion?: Function;
  deeplinkUrls?: any;
};

type State = {
  message: UserMessage;
  deeplinkSelectValue: DeeplinkOption | null;
  uploading: boolean;
};

class GridKey extends React.Component<GridProps> {
  render() {
    return (
      <Grid item={true} md={2} xs={12} {...this.props}>
        {this.props.children}
      </Grid>
    );
  }
}

class GridValue extends React.Component<GridProps> {
  render() {
    return (
      <Grid item={true} md={4} xs={12} {...this.props}>
        {this.props.children}
      </Grid>
    );
  }
}

class Info extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      message: props.message,
      uploading: false,
      deeplinkSelectValue: null,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.message !== nextProps.message) {
      this.setState({ message: nextProps.message });
    }
  }

  editFields = (fieldsToUpdate: {}) => {
    let mutableObj = {};
    for (let key of Object.keys(fieldsToUpdate)) {
      let value = fieldsToUpdate[key];
      mutableObj[key] = { $set: value };
    }
    const updatedMessage = update(this.state.message, mutableObj);
    this.setState({
      message: updatedMessage,
    });
    this.props.onChangeMessage(updatedMessage);
  };

  onDeeplinkSelect = (value: string) => {
    const deeplinkObject: DeeplinkOption =
      value === ""
        ? { url: "", require_uid: false }
        : this.getDeepLinkOptions().find((d) => d.url === value);
    this.setState({
      deeplinkSelectValue: deeplinkObject,
    });
    this.editFields({
      deeplink_action_path: deeplinkObject.url,
      deeplink_action_uid: "",
    });
  };

  onDeeplinkUidChange = (value: string) => {
    this.editFields({ deeplink_action_uid: value });
  };

  getDeepLinkOptions(): Array<DeeplinkOption> {
    return (
      (this.props.deeplinkUrls &&
        this.props.deeplinkUrls.user_message_deeplink_urls) ||
      []
    );
  }

  inputForField = (name: string, value: string) => {
    return (
      <TextField
        style={{ width: "100%" }}
        type={"text"}
        name={name}
        value={value || ""}
        onChange={(event) => this.editFields({ [name]: event.target.value })}
      />
    );
  };

  uploadFile = (event: any) => {
    if (!event.target.files[0]) {
      return;
    }
    this.setState({ uploading: true });
    PosConsoleApi.postMultipart("user_messages/image", {
      user_message_id: this.state.message.id,
      image: event.target.files[0],
    })
      .then((response) => response.json())
      .then((response) => {
        this.setState({ uploading: false });

        this.editFields({
          icon: response.url,
          icon_identifier: response.identifier,
        });
      })
      .catch((error) => alert(error));
  };

  renderReadOnly = () => {
    const message: UserMessage = this.props.message;
    return (
      <Grid alignItems="center" container={true} spacing={24}>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Title:</b>
        </GridKey>
        <GridValue>{message.title}</GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Description:</b>
        </GridKey>
        <GridValue>{message.description}</GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Created:</b>
        </GridKey>
        <GridValue> {message.created_at} </GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Last Updated:</b>
        </GridKey>
        <GridValue>{message.updated_at}</GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Expiry:</b>
        </GridKey>
        <GridValue> {message.expires_at} </GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Target Type:</b>
        </GridKey>
        <GridValue>{message.user_targeting_type}</GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Version:</b>
        </GridKey>
        <GridValue>
          <b>{message.version}</b>
          <Button
            color="primary"
            onClick={() => {
              this.props.onBumpVersion();
            }}
            disabled={message.user_targeting_type !== "draft"}
          >
            Bump
          </Button>
        </GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Deeplink Action:</b>
        </GridKey>
        <GridValue>{message.deeplink_action}</GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>External Action:</b>
        </GridKey>
        <GridValue> {message.external_action} </GridValue>
      </Grid>
    );
  };

  renderEdit = () => {
    const message: UserMessage = this.state.message;
    const showUidEntry: boolean =
      (this.state.deeplinkSelectValue &&
        this.state.deeplinkSelectValue.require_uid) ||
      !!message.deeplink_action_uid;
    return (
      <Grid alignItems="center" container={true} spacing={24}>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Title:</b>
        </GridKey>
        <GridValue>{this.inputForField("title", message.title)}</GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Description:</b>
        </GridKey>
        <GridValue>
          {this.inputForField("description", message.description)}
        </GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Created:</b>
        </GridKey>
        <GridValue> {message.created_at} </GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Last Updated:</b>
        </GridKey>
        <GridValue>{message.updated_at}</GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Expiry:</b>
        </GridKey>
        <GridValue>
          <DateTimePicker
            autoOk={true}
            ampm={false}
            showTodayButton={true}
            fullWidth={true}
            invalidLabel="Please enter date"
            value={message.expires_at ? toMoment(message.expires_at) : moment()}
            onChange={(momentEvent) =>
              this.editFields({ expires_at: fromMoment(momentEvent) })
            }
          />
        </GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Target Type:</b>
        </GridKey>
        <GridValue>{message.user_targeting_type}</GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Version:</b>
        </GridKey>
        <GridValue> {message.version} </GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Deeplink Action:</b>
        </GridKey>
        <GridValue style={{ display: "flex", alignItems: "center" }}>
          <TextField
            style={{
              flex: showUidEntry ? "0 0 70%" : "0 0 100%",
            }}
            select={true}
            margin="none"
            fullWidth={true}
            label="Select"
            value={message.deeplink_action_path || ""}
            onChange={(event) => this.onDeeplinkSelect(event.target.value)}
            helperText="Please select your deeplink (DEPRECTATED)"
          >
            <MenuItem key={0} value="">
              None
            </MenuItem>
            {this.getDeepLinkOptions().map((option, i) => (
              <MenuItem key={i + 1} value={option.url}>
                {option.url}
              </MenuItem>
            ))}
          </TextField>
          {showUidEntry ? (
            <TextField
              style={{ flex: "0 0 30%", marginLeft: "10px" }}
              type={"text"}
              value={message.deeplink_action_uid}
              onChange={(event) => this.onDeeplinkUidChange(event.target.value)}
            />
          ) : null}
        </GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>External Action (DEPRECATED):</b>
        </GridKey>
        <GridValue>
          {this.inputForField("external_action", message.external_action)}
        </GridValue>
      </Grid>
    );
  };

  renderImage = () => {
    const message: UserMessage = this.state.message;
    return (
      <div style={{ display: "flex", alignItems: "center", marginTop: "20px" }}>
        <b style={{ marginRight: "10px" }}>Image:</b>
        {message.icon ? (
          <div style={{ flex: "0 0 25%" }}>
            <div
              style={{
                position: "relative",
                paddingBottom: "56.25%",
                height: 0,
              }}
            >
              <img
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  maxWidth: "100%",
                }}
                alt="Message"
                src={message.icon}
              />
            </div>
          </div>
        ) : (
          "N/A"
        )}
        {this.props.editMode ? (
          <div style={{ marginLeft: "10px" }}>
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="message-icon-upload"
              type="file"
              onChange={(event) => this.uploadFile(event)}
            />
            <label htmlFor="message-icon-upload">
              <Button
                id="message-icon-upload"
                component="span"
                disabled={this.state.uploading}
                variant="contained"
                color="secondary"
              >
                {this.state.uploading ? "Uploading..." : "Upload"}
              </Button>
            </label>
          </div>
        ) : null}
      </div>
    );
  };

  render() {
    return (
      <div>
        <div
          style={{
            fontSize: "14px",
            paddingTop: "10px",
            width: "100%",
          }}
        >
          {this.props.editMode ? this.renderEdit() : this.renderReadOnly()}
        </div>
        {this.props.message.id ? this.renderImage() : null}
      </div>
    );
  }
}

const deeplinksQuery = graphql<any, Props>(
  gql`
    query deeplinkUrls {
      user_message_deeplink_urls {
        url
        require_uid
      }
    }
  `,
  { name: "deeplinkUrls" }
);

export default compose(deeplinksQuery)(Info);
